import React, { useEffect, useState } from "react";

import {
  validarVisualizar,
  validarSePassouDaDataDeValidade,
} from "../../services/utils";

import { Modal, Menu, Dropdown, List, Spin } from "antd";
import { saveAs } from "file-saver";

import menuInfo from "../../assets/iconsMenu/menuInfo.svg";
import menuFavorito from "../../assets/iconsMenu/menuFavorito.svg";
import menuRemover from "../../assets/iconsMenu/menuRemover.svg";
import iconLinkSvg from "../../assets/icons/iconLinkVisualizar.svg";
import iconDownloadSvg from "../../assets/icons/iconDownloadVisualizar.svg";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import IcTresPontos from "../../assets/icons/iconeTresPontinhos.svg";
import "./styles.scss";

import { registrarDownloadArquivo } from "../../services/http/dashboardService";
import { CloseOutlined } from "@mui/icons-material";
import lang from "../../assets/idioma/idiomas";

const ModalVisualizar = ({
  closeModal,
  openModal,
  arquivo,
  handleGerarLinkUnico,
  IsAdmin,
  handleRemoverFavorito,
  removerItem,
  showInfo,
  favoritar,
}) => {
  const [loading, setLoading] = useState(false);
  const [tipo, setTipo] = useState("");
  const [zoom, setZoom] = useState(false);

  const [altura, setAltura] = useState(null);
  const [largura, setLargura] = useState(null);

  useEffect(() => {
    setTipo(validarVisualizar(arquivo.extensao));

    if (tipo === "imagem") {
      const img = new Image();
      img.src = arquivo.urlArquivo;
      img.onload = () => {
        setLargura(img.width);
        setAltura(img.height);
      };
    }
  }, [tipo]);

  const handleDownload = async (arquivo) => {
    registrarDownloadArquivo(arquivo.id);
    saveAs(arquivo.urlArquivo, arquivo.nome);
  };

  const showMenu = (id, tipo, item) => {
    return (
      <div className="menu">
        <Menu>
          <Menu.Item
            key="2"
            onClick={() => showInfo(id, tipo)}
            icon={<img src={menuInfo} />}
          >
            Info
          </Menu.Item>
          {item.ehFavorito ? (
            <Menu.Item
              key="3"
              onClick={() => handleRemoverFavorito(item)}
              icon={<img src={menuFavorito} />}
            >
              Remover favorito
            </Menu.Item>
          ) : (
            <Menu.Item
              key="3"
              onClick={() => favoritar(item)}
              icon={<img src={menuFavorito} />}
            >
              Favorito
            </Menu.Item>
          )}
          {IsAdmin.toLocaleLowerCase() == "true" && (
            <hr className="linha-menu" />
          )}

          {IsAdmin.toLocaleLowerCase() == "true" && (
            <>
              <Menu.Item
                key="12"
                onClick={() => removerItem(id, tipo)}
                icon={<img src={menuRemover} />}
              >
                Remover
              </Menu.Item>
            </>
          )}
        </Menu>
      </div>
    );
  };

  const url = [{ uri: arquivo.urlArquivo }];

  return (
    <Modal
      visible={openModal}
      className="modal-visualizar"
      // onCancel={closeModal}
      closable={false}
      footer={[]}
      destroyOnClose={true}
    >
      <CloseOutlined onClick={closeModal} className="custom-close-icon" />
      <div className="content-visualizar">
        <div className="header-visualizar">
          <div className="buttons-visualizar">
            {!validarSePassouDaDataDeValidade(arquivo.dataVencimento) ? (
              <button
                className="visualizar-button-download"
                onClick={() => handleDownload(arquivo)}
              >
                <Spin spinning={loading}>
                  <img src={iconDownloadSvg} /> <span>Fazer download</span>
                </Spin>
              </button>
            ) : null}
            {!validarSePassouDaDataDeValidade(arquivo.dataVencimento) ? (
              <button
                className="visualizar-button-obter-link"
                onClick={() => handleGerarLinkUnico(arquivo)}
              >
                <img src={iconLinkSvg} /> <span>{lang.Obter_link}</span>
              </button>
            ) : null}
          </div>
          <div className="nome-arquivo">
            <span>{arquivo.nome}</span>
          </div>
          <div>
            {arquivo.tipo != null && (
              <td className="text-right">
                <List.Item className="list-item">
                  <Dropdown.Button
                    trigger={["click"]}
                    className="button-list"
                    icon={<img src={IcTresPontos} alt="Ícone" />}
                    overlay={() =>
                      showMenu(
                        arquivo.id,
                        arquivo.tipo == 0 ? "pasta" : "arquivo",
                        arquivo
                      )
                    }
                    placement="bottomLeft"
                  ></Dropdown.Button>
                </List.Item>
              </td>
            )}
          </div>
        </div>
        <div className="body-visualizar">
          {tipo == "video" && (
            <video
              controls
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              <source src={arquivo.urlArquivo}></source>
            </video>
          )}
          {tipo == "pdf" && (
            <embed
              src={arquivo.urlArquivo}
              style={{
                width: "100%",
                height: "100%",
              }}
            ></embed>
          )}
          {tipo == "imagem" && (
            <div
              className="divImgPrincipal"
              onClick={() => {
                setZoom((zoom) => !zoom);
              }}
            >
              {zoom ? (
                <img
                  className={
                    altura > largura
                      ? "ImgZommLargura"
                      : altura < largura
                      ? "ImgZommAltura"
                      : "ImgZomm"
                  }
                  src={arquivo.urlArquivo}
                />
              ) : (
                <img
                  className={
                    altura > largura
                      ? "ImgPequena"
                      : altura < largura
                      ? "ImgPequena"
                      : "ImgPequenaQuadrado"
                  }
                  src={arquivo.urlArquivo}
                />
              )}
            </div>
          )}

          {tipo == "word" && (
            <>
              <DocViewer
                style={{
                  width: "100%",
                  height: "100%",
                }}
                documents={url}
                pluginRenderers={DocViewerRenderers}
              />
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModalVisualizar;
